import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
// Gonna need this until we see enough green here: https://caniuse.com/#feat=resizeobserver
import ResizeObserver from "resize-observer-polyfill";
import { ElementObserverContext } from "./ElementObserverContext";
export const ElementObserver = (props) => {
    const observer = useRef();
    const element = useRef(null);
    const [observedElementState, setObservedElementState] = useState({
        activeBreakpoints: [],
        currentBreakpoint: props.breakpoints ? props.breakpoints[0] : null,
        observedElementRect: {},
        observedElementBottom: null,
        observedElementHeight: null,
        observedElementLeft: null,
        observedElementRight: null,
        observedElementTop: null,
        observedElementWidth: null,
        observedElementX: null,
        observedElementY: null
    });
    const handleResize = useCallback((entries) => {
        const { breakpoints } = props;
        const observedElementRect = entries[0].contentRect;
        const nextState = {
            observedElementRect,
            observedElementBottom: observedElementRect.bottom,
            observedElementHeight: observedElementRect.height,
            observedElementLeft: observedElementRect.left,
            observedElementRight: observedElementRect.right,
            observedElementTop: observedElementRect.top,
            observedElementWidth: observedElementRect.width,
            observedElementX: observedElementRect.x,
            observedElementY: observedElementRect.y,
            activeBreakpoints: [],
            currentBreakpoint: null
        };
        setObservedElementState((prevState) => {
            if (!breakpoints) {
                // If no breakpoints, always update
                return nextState;
            }
            const activeBreakpoints = breakpoints.filter((b) => nextState.observedElementWidth && b < nextState.observedElementWidth);
            const currentBreakpoint = breakpoints[activeBreakpoints.length - 1];
            if (activeBreakpoints.length === prevState.activeBreakpoints.length) {
                // No change. Will not re-render.
                return prevState;
            }
            nextState.currentBreakpoint = currentBreakpoint;
            nextState.activeBreakpoints = activeBreakpoints;
            return nextState;
        });
    }, [props]);
    const observeTarget = useCallback((el) => {
        element.current = el;
    }, []);
    useEffect(() => {
        if (element.current !== null) {
            observer.current = new ResizeObserver(handleResize);
            observer.current.observe(element.current);
        }
        return () => {
            if (observer.current) {
                observer.current.disconnect();
                observer.current = undefined;
            }
        };
    }, [handleResize]);
    return (_jsx(ElementObserverContext.Provider, { value: observedElementState, children: props.children({
            observeTarget,
            observedElement: element.current,
            ...observedElementState
        }) }));
};
ElementObserver.displayName = "ElementObserver";
